import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import AppModal from '../../../../common/AppModal';

const UndoCancellationModal = ({
  show,
  onHide,
  onExited,
  onSubmit,
  submitting
}) => {

  return (
    <AppModal
      show={show}
      onHide={onHide}
      onExited={onExited}
      onSubmit={onSubmit}
      heading="Undo Cancellation"
      submitLabel="Undo Cancellation"
      submitting={submitting}
      showCancelButton
    >
      <Row>
        <Col className="text-center">
          <ExclamationTriangleFill className="text-danger" size={30} />
          <h6 className="mt-3">Undo the cancellation request for this order?</h6>
        </Col>
      </Row>
    </AppModal>
  );
};

export default UndoCancellationModal;
